export default __webpack_public_path__ + "static/media/Avaar.3ab8942d.png";